export const ADMIN_GIAO_VIEC_PREFIX_URL = '/admin-giao-viec'
